export enum EXCHANGES {
  NSE = 'NSE',
  BSE = 'BSE',
  ALL = 'All',
}

export enum CHART_PERIOD {
  ONE_WEEK = 'w1',
  ONE_MONTH = 'm1',
  SIX_MONTH = 'm6',
  ONE_YEAR = 'y1',
  FIVE_YEAR = 'y5',
}

export enum OPTION52WEEk {
  HIGH = 'High',
  LOW = 'Low',
}

export enum OPTION_GAINER_LOSERS {
  GAINERS = 'gain',
  LOSSERS = 'lose',
}

export enum OPTION_VOLUME_VALUE {
  VOLUME = 'volume',
  VALUE = 'value',
}

export enum MARKET_CAP_TYPE {
  LARGE = 'LARGE',
  MID = 'MID',
  SMALL = 'SMALL',
}

export enum OPTION_PERFORMER {
  OUT = 'Out',
  UNDER = 'Under',
}

export enum IPO_RADIO_TYPE {
  ALL = 'All',
  SME = 'SME',
  MAIN = 'Mainboard',
}

export enum COLOR_CODES {
  GREEN = '#269F00',
  RED = '#C43A4B',
  SKY_BLUE = '#0BC1A2',
  ORANGE = '#FF6347',
}

export enum CHART_PERIOD_LEVELS {
  ONEDAY = 'D1',
  ONEWEEK = 'W1',
  ONEMONTH = 'M1',
  SIXMONTH = 'M6',
  ONEYEAR = 'Y1',
  FIVEYEAR = 'Y5',
}

export const CHART_PERIOD_LABELS: { [key in CHART_PERIOD_LEVELS]: string } = {
  [CHART_PERIOD_LEVELS.ONEDAY]: '1D',
  [CHART_PERIOD_LEVELS.ONEWEEK]: '1W',
  [CHART_PERIOD_LEVELS.ONEMONTH]: '1M',
  [CHART_PERIOD_LEVELS.SIXMONTH]: '6M',
  [CHART_PERIOD_LEVELS.ONEYEAR]: '1Y',
  [CHART_PERIOD_LEVELS.FIVEYEAR]: '5Y',
};

export enum STOCK_CHART_PERIOD_LEVELS {
  ONEWEEK = 'W1',
  ONEMONTH = 'M1',
  SIXMONTH = 'M6',
  ONEYEAR = 'Y1',
  FIVEYEAR = 'Y5',
}

export const PERIOD_LABELS: { [key: string]: string } = {
  W1: '1W',
  M1: '1M',
  M6: '6M',
  Y1: '1Y',
  Y5: '5Y',
};

export enum INDICES_SECTION_WRAPPER_TYPE {
  prefix = 'indices',
}
